module.exports = __webpack_public_path__ + "static/img/bg_2@2x.f8ef33b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anniversary/bg_2@2x.png
// module id = WJsD
// module chunks = 0